import React from 'react'
import {Header, List, Message} from 'semantic-ui-react'

const SetupYourTeam = () => {
  return (
    <div className='doc-section'>
      <Header as='h2'>Set Up Your Team</Header>
      <Message>
        <Message.Header>Tips</Message.Header>
        <Message.List>
          <Message.Item>If a user does not receive their invite email you can click the "Cog" and click "Resend"</Message.Item>
          <Message.Item>As a fallback, you can always click the "Cog" and click "Copy Invitation Link" to send it yourself.</Message.Item>
        </Message.List>
      </Message>
      <Header as='h3' dividing>Steps:</Header>
      <List relaxed>
        <List.Item>1. Navigate to the top nav dropdown menu and click "Users".</List.Item>
        <List.Item>2. Click the "Invite User" button.</List.Item>
        <List.Item>3. Enter the users "email", "first", and "last" name.</List.Item>
        <List.Item>4. Click the "Invite" button</List.Item>
        <List.Item>5. The user will receive a link to accept the invitation.</List.Item>
        <List.Item>6. Upon clicking this link, the user will be asked to create a password or sign in.</List.Item>
        <List.Item>7. Upon creating a password or signing in this account will now show in the user's top nav dropdown.</List.Item>
        <List.Item>8. The user will need to select this account from their top nav dropdown to see and work with the mocks it contains.</List.Item>
      </List>
    </div>
  )
}

export {SetupYourTeam}

export default SetupYourTeam